import WordSeparator from './Root.vue';
import SpecialCharacterRemoverPage from './views/SpecialCharacterRemoverPage.vue';

export default {
  path: 'remover-caracteres-especiais',
  name: 'admin-special-character-remover',
  component: WordSeparator,
  redirect: '/novo',
  children: [
    {
      path: 'novo',
      name: 'admin-special-character-remover-new',
      component: SpecialCharacterRemoverPage,
    },
  ],
};
